import { Transmit } from '@adonisjs/transmit-client'

export default defineNuxtPlugin(() => {
  const { apiUrl } = useRuntimeConfig().public
  return { provide: { transmit: new Transmit({ baseUrl: apiUrl }) } }
})
